import metadata from "libphonenumber-js/metadata.full.json";

export const getMobileMaxLength = (countryCode) => {
  if (!countryCode) return 15;
  const country = metadata.countries?.[countryCode];
  if (!country) return 15;
  const types = country[11];
  if (!Array.isArray(types)) return 15;
  let lengths = [];
  types.forEach((type) => {
    if (Array.isArray(type) && Array.isArray(type[1])) {
      lengths.push(...type[1]);
    }
  });
  if (!lengths.length) {
    if (Array.isArray(country[3])) {
      lengths = country[3];
    } else {
      return 15;
    }
  }
  return Math.max(...lengths);
};
